import {createSvgIcon} from '../create-svg-icon';

export const BookmarkAddedIcon = createSvgIcon(
  <path d="M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm.83-2L15 6.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L17.83 9z" />
, 'BookmarkAddedOutlined');
